<template>
	<div>
		<p v-if="$tera.project.TrialWizard.trialRegistered">
			{{ selectRandom([
				"The trial will be registered on ",
				"The trial is scheduled to be registered on ",
				"The registration date for the trial is ",
				"The trial is planned to be registered on "
			]) }}
			{{ $tera.project.TrialWizard.trialRegistered }}.
		</p>
		<p v-if="$tera.project.TrialWizard.trialRegistNumber">
			{{ selectRandom([
				"The trial will be registered on ",
				"The trial is scheduled to be registered on ",
				"The registration date for the trial is ",
				"The trial is planned to be registered on "
			]) }}
			{{ $tera.project.TrialWizard.trialRegistNumber }}.
		</p>
		<p v-if="$tera.project.TrialWizard.protocolVersion">
			{{ selectRandom([
				"This protocol was last edited on ",
				"The most recent update to this protocol was on ",
				"This protocol's latest version was edited on ",
				"The protocol was last updated on ",
				"The protocol version was last edited on "
			]) }}
			{{ $tera.project.TrialWizard.protocolVersion }}.
		</p>
		<p v-if="$tera.project.TrialWizard.protocolDate">
			{{ selectRandom([
				"This protocol was last registered on ",
				"The protocol was last registered on ",
				"This protocol's registration date is ",
				"The protocol's most recent registration was on ",
				"This protocol was last updated and registered on "
			]) }}
			{{ $tera.project.TrialWizard.protocolDate }}.
		</p>
		<p v-if="$tera.project.TrialWizard.supports">
			{{ selectRandom([
				"Sources and types of financial, material, and other support include ",
				"The sources and types of financial, material, and other support are ",
				"Support for this trial includes financial, material, and other sources such as ",
				"The financial, material, and other support for this trial include ",
				"This trial receives financial, material, and other support from sources like "
			]) }}
			{{ $tera.project.TrialWizard.supports }}
		</p>
		<p v-if="$tera.project.TrialWizard.sponsors">
			{{ selectRandom([
				"The study is sponsored by ",
				"This study is funded by ",
				"The sponsorship for this study comes from ",
				"This study receives sponsorship from ",
				"The sponsors of this study are "
			]) }}
			{{ joinArrayWithAnd($tera.project.TrialWizard.sponsors) }}.
		</p>
		<p v-if="$tera.project.TrialWizard.sponsorRole">
			{{ selectRandom([
				"The role of the funders or sponsors in the study is ",
				"Funders or sponsors played the following role in the study: ",
				"The involvement of funders or sponsors in the study is ",
				"The sponsor(s) contributed in the following way to the study: ",
				"The role played by the funders or sponsors in the study is "
			]) }}
			{{ $tera.project.TrialWizard.sponsorRole }}
		</p>
		<p v-if="$tera.project.TrialWizard.sponsorInfo">
			{{ selectRandom([
				"Contact ",
				"To get more details, contact ",
				"For more information regarding this trial, contact ",
				"To learn more about this trial, reach out to ",
				"For inquiries about this trial, please contact "
			]) }}
			{{ $tera.project.TrialWizard.sponsorInfo }}
			{{ selectRandom([" for information regarding this trial.", "."]) }}
		</p>
		<p v-if="$tera.project.TrialWizard.reDescription">
			{{ $tera.project.TrialWizard.reDescription }}
		</p>
		<p v-if="$tera.project.TrialWizard.researchObjectives">
			{{ $tera.project.TrialWizard.researchObjectives }}
		</p>
		<p v-if="$tera.project.TrialWizard.bioSpecimens">
			{{ $tera.project.TrialWizard.bioSpecimens }}
		</p>
	</div>
</template>
<script>
import OutputMixin from "@/mixins/OutputMixin.js";
export default {
	name: "OutputStudyInformation",
	mixins: [OutputMixin]
};
</script>
